export function map_campaign_report(report) {
  report.atosa_cpc = {value: report.click.value !== 0 ? Math.floor(report.cost.value / report.click.value) : 0}
  report.cpm = {value: report.impression.value !== 0 ? Math.floor(report.cost.value / report.impression.value * 1000) : 0}
  report.aov = {value: report.broad_order.value !== 0 ? Math.floor(report.broad_gmv.value / report.broad_order.value) : 0}

  const impression = report.impression ? report.impression.value : 0
  const ctr = report.ctr ? report.ctr.value : 0
  const cr = report.cr ? report.cr.value : 0
  const action = impression * ctr * cr
  report.cpa = {value: action && report.cost ? Math.floor(report.cost.value / action) : 0}

  return report
}

export function map_detail_campaign_report(report) {
  report.position = 0
  report.seo_position = 0
  report.display_position = 0
  report.shopee_volume = 0

  report.average = Math.round(report.location_in_ads / report.impression) + 1
  report.cir = Math.floor(report.broad_gmv) > 0 ? Math.round(Math.floor(report.cost) / Math.floor(report.broad_gmv) * 100) : 0
  report.atosa_cpc = report.click !== 0 ? Math.floor(report.cost / report.click) : 0
  report.cpm = report.impression !== 0 ? Math.floor(report.cost / report.impression * 1000) : 0
  report.aov = report.broad_order !== 0 ? Math.floor(report.broad_gmv / report.broad_order) : 0

  const action = report.impression * report.ctr * report.cr
  report.cpa = action ? Math.floor(report.cost / action) : 0

  return report
}

export function map_graph_response(report_aggregate) {
  if (!report_aggregate) return {}

  const metrics = {...report_aggregate}
  metrics.broad_gmv = metrics.broad_gmv /= 100000
  metrics.cost /= 100000
  metrics.order = metrics.broad_order
  metrics.order_amount = metrics.broad_order_amount
  metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
  metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(2) : 0
  metrics.broad_roi = +(metrics.broad_roi).toFixed(2)
  metrics.atosa_cpc = +metrics.click ? Math.floor(+metrics.cost / +metrics.click) : 0
  metrics.cr = +metrics.click ? (+metrics.broad_order / +metrics.click * 100).toFixed(2) : 0
  metrics.cpm = +metrics.impression ? Math.floor(+metrics.cost / +metrics.impression * 1000) : 0
  metrics.aov = metrics.broad_order !== 0 ? Math.floor(metrics.broad_gmv / metrics.broad_order) : 0

  const action = metrics.impression * (metrics.ctr / 100) * (metrics.cr / 100)
  metrics.cpa = action ? Math.floor(metrics.cost / action) : 0

  return metrics
}

export function map_graph_by_time_response(report_by_time) {
  if (!report_by_time) return []

  return report_by_time.map(i => {
    const metrics = i.metrics
    metrics.broad_gmv = metrics.broad_gmv /= 100000
    metrics.cost /= 100000
    metrics.order = metrics.broad_order
    metrics.order_amount = metrics.broad_order_amount
    metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(2) : 0
    metrics.broad_roi = +(metrics.broad_roi).toFixed(2)
    metrics.atosa_cpc = +metrics.click ? Math.floor(+metrics.cost / +metrics.click) : 0
    metrics.cpm = +metrics.impression ? Math.floor(+metrics.cost / +metrics.impression * 1000) : 0
    metrics.aov = metrics.broad_order !== 0 ? Math.floor(metrics.broad_gmv / metrics.broad_order) : 0

    const action = metrics.impression * metrics.ctr * metrics.cr
    metrics.cpa = action ? Math.floor(metrics.cost / action) : 0

    return {timestamp: +i.key, ...metrics}
  })
}

export function calculate_campaign_report(report) {
  if (!report) return {}

  const metrics = {...report}
  metrics.ctr = +report
}

export function map_search_report_by_key(response) {
  if (!response) return null

  if (!response.data) return []

  const data = response.data.map(i => {
    const metrics = {...i.metrics}
    metrics.broad_gmv /= 100000
    metrics.direct_gmv /= 100000
    metrics.cpc /= 100000
    metrics.cpdc /= 100000
    metrics.cost /= 100000
    metrics.atosa_cpc = +metrics.click ? Math.floor(+metrics.cost / +metrics.click) : 0
    metrics.cpm = +metrics.impression ? Math.floor(+metrics.cost / +metrics.impression * 1000) : 0
    metrics.aov = metrics.broad_order !== 0 ? Math.floor(metrics.broad_gmv / metrics.broad_order) : 0

    const action = metrics.impression * metrics.ctr * metrics.cr
    metrics.cpa = action ? Math.floor(metrics.cost / action) : 0

    return {keyword: i.key, ...metrics}
  })

  return {data}
}

export function map_targeting_report_by_key(response) {
  if (!response) return null

  if (!response.data) return []

  return response.data.map(i => {
    const metrics = {...i.metrics}
    metrics.broad_gmv /= 100000
    metrics.direct_gmv /= 100000
    metrics.cpc /= 100000
    metrics.cpdc /= 100000
    metrics.cost /= 100000
    metrics.cpm = +metrics.impression ? Math.floor(+metrics.cost / +metrics.impression * 1000) : 0
    metrics.aov = metrics.broad_order !== 0 ? Math.floor(metrics.broad_gmv / metrics.broad_order) : 0

    const action = metrics.impression * metrics.ctr * metrics.cr
    metrics.cpa = action ? Math.floor(metrics.cost / action) : 0

    let key = i.key
    if (key === 'daily_discover') key = '2'
    if (key === 'you_may_also_like') key = '5'
    if (key === 'targeting') key = '8'

    return {placement: key, ...metrics}
  })
}

function map_shopee_campaign_type(campaign, include_all) {
  if (campaign.type === 'shop_manual') {
    return {
      shopee_type: 'shop',
      type: 'shop',
      bidding_type: 'manual'
    }
  }
  if (campaign.type === 'shop_auto') {
    return {
      shopee_type: 'shop',
      type: 'shop',
      bidding_type: 'auto'
    }
  }
  if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'all') {
    return {
      shopee_type: 'product',
      type: include_all ? 'all' : 'keyword',
      bidding_type: campaign.manual_product_ads.bidding_strategy
    }
  }
  if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'search_product') {
    return {
      shopee_type: 'product',
      type: 'keyword',
      bidding_type: campaign.manual_product_ads.bidding_strategy
    }
  }
  if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'targeting') {
    return {
      shopee_type: 'product',
      type: 'targeting',
      bidding_type: campaign.manual_product_ads.bidding_strategy
    }
  }
}

function map_shopee_campaign_placement(campaign) {
  return []

  if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'search_product') {
    return [{
      placement: 0,
      extinfo: {keywords: []}
    }]
  }
  if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'targeting') {
    return [{
      placement: 2,
      extinfo: {target: {}}
    }, {
      placement: 5,
      extinfo: {target: {}}
    }]
  }
  if (campaign.manual_product_ads && campaign.manual_shop_ads.shop_placement === 'search_shop') {
    return [{
      placement: 2,
      extinfo: {keywords: {}}
    }]
  }
}

const reduce_100k_list = new Set(['broad_gmv', 'direct_gmv', 'cost', 'cpc', 'cpdc'])

export function map_campaign_data(response, include_all = false) {
  if (!response.data || !response.data.entry_list) return []

  const data = response.data.entry_list.map(i => {
    return {
      campaign: {
        ...i.campaign,
        campaignid: i.campaign.campaign_id,
        state: i.state,
        daily_quota: Math.floor(i.campaign.daily_budget / 100000),
        total_quota: 0,
        name: i.title,
        image_url: i.image, ...map_shopee_campaign_type(i, include_all)
      },

      advertisements: map_shopee_campaign_placement(i),

      report: Object.keys(i.report).reduce((result, key) => {
        const ratio = i.ratio && i.ratio[key] ? i.ratio[key] : 0
        const value = reduce_100k_list.has(key) ? Math.floor(i.report[key] / 100000) : i.report[key]
        result[key] = {
          ratio: ratio,
          value: value
        }

        return result
      }, {}),

      product: {
        itemid: i.manual_product_ads ? i.manual_product_ads.item_id : '',
        name: i.title,
        images: i.image
      },
      title: i.title,
      image: i.image,
      type: i.type,

      md5: i.manual_product_ads ? i.manual_product_ads.item_id : ''
    }
  })

  return {data: {campaign_ads_list: data}}
}

export function make_uuid() {
  var t = {
    rdQpc: function (t, e) {
      return t + e
    }
  }, e = (new Date).getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (function (n) {
    var r = t.rdQpc(e, 16 * Math.random()) % 16 | 0
    return e = Math.floor(e / 16), ('x' == n ? r : 7 & r | 8).toString(16)
  }))
}

export function get_shopee_campaign_type(_placement) {
  const placement = typeof _placement === 'object' ? Number(_placement.placement) : Number(_placement)

  if (placement === 0) return 'product'
  if (placement === 4) return 'product'
  if (placement === 1) return 'product'
  if (placement === 2) return 'product'
  if (placement === 8) return 'product'
  if (placement === 3) return 'shop'
  if (placement === 20) return 'shop'

  return ''
}

export const action_template = {
  // campaign
  action_campaign: '',
  update_price_type_campaign: 'value',
  update_price_value_campaign: '',
  update_min_price_campaign: null,
  update_min_price_campaign_type: undefined,
  update_max_price_campaign: null,
  default_cpc_campaign: '',
  cpc_range_campaign: null,
  cpc_type_campaign: 'campaign',
  // match_type_0
  action_match_type_0: '',
  update_price_type_match_type_0: 'value',
  update_price_value_match_type_0: '',
  update_min_price_match_type_0: null,
  update_type_min_price_match_type_0: 'value',
  update_value_min_price_match_type_0: null,
  update_max_price_match_type_0: null,
  update_type_max_price_match_type_0: 'value',
  update_value_max_price_match_type_0: null,
  default_cpc_match_type_0: '',
  cpc_range_match_type_0: null,
  cpc_type_match_type_0: 'keyword_past7days',
  action_match_type_0_to_match_type_1_type: '',
  action_match_type_0_to_match_type_1_value: null,
  // match_type_1
  action_match_type_1: '',
  update_price_type_match_type_1: 'value',
  update_price_value_match_type_1: '',
  update_min_price_match_type_1: null,
  update_type_min_price_match_type_1: 'value',
  update_value_min_price_match_type_1: null,
  update_max_price_match_type_1: null,
  update_type_max_price_match_type_1: 'value',
  update_value_max_price_match_type_1: null,
  default_cpc_match_type_1: '',
  cpc_range_match_type_1: null,
  cpc_type_match_type_1: 'keyword_past7days',
  action_match_type_1_to_match_type_0_type: '',
  action_match_type_1_to_match_type_0_value: null,
  // placement_2
  action_placement_2: '',
  update_price_type_placement_2: 'value',
  update_price_value_placement_2: '',
  update_min_price_placement_2: null,
  update_type_min_price_placement_2: 'value',
  update_value_min_price_placement_2: null,
  update_max_price_placement_2: null,
  update_type_max_price_placement_2: 'value',
  update_value_max_price_placement_2: null,
  default_cpc_placement_2: '',
  cpc_range_placement_2: null,
  cpc_type_placement_2: 'keyword_past7days',
  // placement_5
  action_placement_5: '',
  update_price_type_placement_5: 'value',
  update_price_value_placement_5: '',
  update_min_price_placement_5: null,
  update_type_min_price_placement_5: 'value',
  update_value_min_price_placement_5: null,
  update_max_price_placement_5: null,
  update_type_max_price_placement_5: 'value',
  update_value_max_price_placement_5: null,
  default_cpc_placement_5: '',
  cpc_range_placement_5: null,
  cpc_type_placement_5: 'keyword_past7days'
}

export const ADS_CONSTANTS = {
  MAX_KEYWORDS_LENGTH: 200,
  KEYWORD_MATCH_TYPE_0_MIN: 480, // TODO: Chính xác
  KEYWORD_MATCH_TYPE_1_MIN: 480, // TODO: Mở rộng
  SHOP_MATCH_TYPE_0_MIN: 1000, // TODO: Chính xác
  SHOP_MATCH_TYPE_1_MIN: 1000, // TODO: Mở rộng
  PRODUCT_MANUAL_MIN_DAILY_QUOTA: 5000,
  PRODUCT_ALL_MIN_DAILY_QUOTA: 10000,
  SHOP_MIN_DAILY_QUOTA: 20000
}

export function recalculate_metrics(metrics) {
  metrics.ctr = +metrics.impression ? +metrics.click / +metrics.impression : 0
  metrics.broad_cir = +metrics.broad_gmv ? (+metrics.cost / 100000) / (+metrics.broad_gmv / 100000) : 0
  metrics.direct_cir = +metrics.direct_gmv ? (+metrics.cost / 100000) / (+metrics.broad_gmv / 100000) : 0
  metrics.broad_roi = +metrics.cost ? (+metrics.broad_gmv / 100000) / (+metrics.cost / 100000) : 0
  metrics.direct_roi = +metrics.cost ? (+metrics.direct_gmv / 100000) / (+metrics.cost / 100000) : 0
  metrics.cr = +metrics.click ? +metrics.broad_order / +metrics.click : 0
  metrics.direct_cr = +metrics.click ? +metrics.direct_order / +metrics.click : 0
  metrics.cpc = +metrics.click ? (+metrics.cost / 100000) / +metrics.broad_order : 0
  metrics.cpdc = +metrics.direct_gmv ? (+metrics.cost / 100000) / +metrics.direct_order : 0
}




// WEBPACK FOOTER //
// ./src/addon/ads_function.js